function ExperiencePartnershipLabel() {
  return null
}

ExperiencePartnershipLabel.defaultProps = {
  price: 0,
}

export default ExperiencePartnershipLabel
